var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "1600px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        "append-to-body": true,
        top: "5vh"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-content",
          staticStyle: { "min-height": "400px" }
        },
        [
          _c("partner-form", {
            ref: "partnerForm",
            on: {
              rowChange: _vm.onRowChange,
              audit: _vm.toAudit,
              back: _vm.backToList,
              "refresh-data": _vm.refreshData
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }